import React from "react";
import {
  FormControl,
  FormLabel,
  Input,
  Textarea,
  useColorModeValue,
  Text,
} from "@chakra-ui/react";
import Card from "components/card/Card";

export default function RewardPlanForm({
  name,
  setName,
  description,
  setDescription,
}) {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const accentColor = "#1677ff";

  return (
    <Card mb="20px">
      <Text color={accentColor} fontSize="22px" fontWeight="700" mb="20px">
        Create Reward Plan
      </Text>

      <FormControl mb="24px">
        <FormLabel color={textColor} fontSize="sm" fontWeight="500">
          Reward Plan Name
        </FormLabel>
        <Input
          variant="auth"
          fontSize="sm"
          type="text"
          placeholder="Enter reward plan name"
          mb="24px"
          fontWeight="500"
          size="lg"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <FormLabel color={textColor} fontSize="sm" fontWeight="500">
          Description
        </FormLabel>
        <Textarea
          fontSize="sm"
          placeholder="Enter reward plan description"
          mb="24px"
          size="lg"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </FormControl>
    </Card>
  );
}
